import { render } from "./InternshipBenefitsPerks.vue?vue&type=template&id=29af0906"
import script from "./InternshipBenefitsPerks.vue?vue&type=script&lang=js"
export * from "./InternshipBenefitsPerks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__